// extracted by mini-css-extract-plugin
export default {"items":"M3lCSEhHGZ6B7rN1D+sI+w=="};